import { Box, Text, VStack } from "@chakra-ui/layout";
import { Button } from "@chakra-ui/react";
import { CreditFacilityCreateModal } from "features/credit-facility/CreditFacilityCreateModal";
import EmptyStateImage from "features/credit-facility/empty-state.svg?react";
import { useCreditFacilityListSuspense } from "gen/endpoints/credit-facility/credit-facility";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";
import { useBoolean } from "usehooks-ts";

export const CreditFacilitySetupIndexPage: React.FC = () => {
  const { fundFamilyId } = useRequiredStringParams();

  const { data: creditFacilityList } =
    useCreditFacilityListSuspense(fundFamilyId);
  const { t } = useTranslation(["creditFacility"]);

  const {
    value: isCreateDialogOpen,
    setTrue: openCreateDialog,
    setFalse: closeCreateDialog,
  } = useBoolean();

  if (creditFacilityList.length) {
    const firstCreditFacility = creditFacilityList[0];
    return (
      <Navigate
        replace={true}
        to={
          rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .setup({})
            .creditFacilities({})
            .creditFacility({ creditFacilityId: firstCreditFacility.id }).$
        }
      />
    );
  }

  return (
    <PageContent isFullHeight={true}>
      <PageHeader title={t("creditFacility:title")} />
      <PageBody>
        <>
          <VStack
            flex={1}
            alignItems="center"
            justifyContent="center"
            bg="white"
            borderColor="gray.200"
            borderWidth="1px"
            borderRadius="8px"
            py="32px"
            marginBottom={6}
            spacing="8px"
          >
            <Box mb="16px">
              <EmptyStateImage />
            </Box>
            <Text textStyle="h2">{t("creditFacility:empty.title")}</Text>
            <Text pb={8}>{t("creditFacility:empty.subtitle")}</Text>
            <Button onClick={openCreateDialog}>
              {t("creditFacility:empty.beginCta")}
            </Button>
          </VStack>
          {isCreateDialogOpen && (
            <CreditFacilityCreateModal
              fundFamilyId={fundFamilyId}
              onCloseComplete={closeCreateDialog}
            />
          )}
        </>
      </PageBody>
    </PageContent>
  );
};
